import Source from '@/services/source';
import { addBackendSuffix, makeNameGlueCompatible } from '@/utils/namingConvention';

export async function noLint_makeGlueDatabaseName(
  organizationCloudResourceId: string,
  name: string,
) {
  let glueDatabaseName = addBackendSuffix(makeNameGlueCompatible(name));
  let cloudResourceId = '';
  let done = false;
  while (!done) {
    cloudResourceId = `${organizationCloudResourceId}.${glueDatabaseName}`;
    done = !(await Source.checkGlueDatabaseNameUsed(cloudResourceId));
    if (!done) {
      const suffix = Date.now().toString(36);
      glueDatabaseName = addBackendSuffix(makeNameGlueCompatible(name) + suffix);
    }
  }
  return { glueDatabaseName, cloudResourceId };
}
